import { useCallback, useEffect, useState } from "react";

import isEqual from "lodash/isEqual";

import type { DomainFromAutoselect } from "app/modules/project-from-comparison/types";
import { useIconsQuery } from "app/pages/activation/queries/useIconsQuery";

export const useProjectIcons = (domains: string[]) => {
    const [icons, setIcons] = useState<Record<string, string>>({});
    const { data: fetchedIcons } = useIconsQuery(domains);

    const setIcon = useCallback(
        ({ name, icon }: DomainFromAutoselect) => {
            setIcons((prev) => ({ ...prev, [name]: icon }));
        },
        [setIcons],
    );

    useEffect(() => {
        if (!fetchedIcons) {
            return;
        }

        setIcons((prev) => {
            const merged = { ...prev, ...fetchedIcons };

            if (isEqual(prev, merged)) {
                return prev;
            }

            return merged;
        });
    }, [fetchedIcons]);

    return { icons, setIcon };
};
